const contentBlockExists = document.querySelector(`section.content-block`);

/**
 * Controls the transitions
 */

if (contentBlockExists) {
  window.addEventListener(`load`, checkPosition);
  window.addEventListener(`scroll`, checkPosition);
}

function checkPosition() {
  let windowHeight = window.innerHeight;
  let contentBlockImage = document.querySelectorAll(`.content-block-image`);
  contentBlockImage.forEach((element) => {
    let positionFromTop = element.getBoundingClientRect().top;
    if (positionFromTop - windowHeight <= -350) {
      element.classList.remove(`hide-block`);
    }
  });
}
